export const BY_REGISTRATION_DATE = "BY_REGISTRATION_DATE";
export const BY_RATE = "BY_RATE";
